/**
 * Shared helper for detecting "already cancelled upstream" responses from the
 * EAPI proxy. `EapiClient.invoke` throws errors of the form:
 *
 *   "EAPI POST /v1/trips/:id/cancel returned <status>: <body>"
 *
 * Treat 404 / 409 / "already cancel" / "not found" responses as success so
 * that retries after a partial-success cancel (upstream cleared, local DB
 * write failed) don't get stuck blocking on the upstream call forever.
 */
export function isAlreadyCancelledUpstreamError(err: unknown): boolean {
  const msg = String((err as any)?.message || err || "").toLowerCase();
  if (msg.includes("returned 404")) return true;
  if (msg.includes("returned 409")) return true;
  if (msg.includes("already cancel")) return true;
  if (msg.includes("not found")) return true;
  return false;
}